import MaintenanceWorkflowForwardingCheckinEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckinEntry'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry'
import MaintenanceWorkflowForwardingFinancialReviewEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/FinancialReviewEntry'
import MaintenanceWorkflowForwardingActions from '../../../Sections/ForwardingActions'

const ExecutionEntryOnGoingFinancialReview = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingActions />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingFinancialReviewEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection showProposalDiagnostic />
    </>
  )
}

export default ExecutionEntryOnGoingFinancialReview
